import { useState, useEffect } from "react";
import "@/App.css";
import axios from "axios";
import { Menu, X, Globe, Calculator, TrendingUp, Briefcase, Mail, Phone, MapPin, ChevronRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [language, setLanguage] = useState("en");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [services, setServices] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [news, setNews] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    service_interest: ""
  });
  const [submitStatus, setSubmitStatus] = useState("");
  const [selectedService, setSelectedService] = useState(null);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);

  useEffect(() => {
    fetchServices();
    fetchCustomers();
    fetchNews();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get(`${API}/services`);
      setServices(response.data.services);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await axios.get(`${API}/customers`);
      setCustomers(response.data);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const fetchNews = async () => {
    try {
      const response = await axios.get(`${API}/news`);
      setNews(response.data.slice(0, 3));
    } catch (error) {
      console.error("Error fetching news:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("sending");
    try {
      await axios.post(`${API}/contact`, formData);
      setSubmitStatus("success");
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        service_interest: ""
      });
      setTimeout(() => setSubmitStatus(""), 3000);
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitStatus("error");
      setTimeout(() => setSubmitStatus(""), 3000);
    }
  };

  const t = {
    en: {
      nav: {
        home: "Home",
        about: "About Us",
        services: "Services",
        customers: "Customers",
        news: "News",
        contact: "Contact"
      },
      hero: {
        title: "Professional Advice Straight From Our Experts",
        subtitle: "We offer a wide range of accounting related professional services",
        description: "Small and medium sized business accounting services, Payrolls, New business formation, reviews, Business integration consulting & more.",
        cta: "Contact Us"
      },
      about: {
        title: "About Us",
        subtitle: "Get to know our story",
        content: "A family operated company founded since 2008. We are a professional's team and dedicated group of individuals who love take care of our customers with more than 30 years of experience. We are ready always to help you in all your needs. We can support you in some professional areas like accounting services, social marketing, web design & others IT services. Always helping you in all your needs."
      },
      services: {
        title: "Our Services",
        subtitle: "Comprehensive solutions for your business needs",
        learnMore: "Learn More",
        close: "Close",
        accountingDetails: "We provide a full suite of management Financial Accounting Services for small and medium-sized businesses. We offers business management accounting, Intuit QuickBooks Solutions and others financial software, Payroll management, small business's financial consulting and more… allowing business owners to not only save money over in-house accounting and ensure their compliance with tax laws, but to make valuable management decisions from their numbers. We offering too the opportunity to help your company with our partners about your corporate taxes and due diligences, integrated inventory and management's corporate software and much more.",
        bookkeepingServicesTitle: "Some bookkeeping services:",
        bookkeepingServicesList: [
          "Accounts Payable & Receivable",
          "Bank Reconciliation",
          "Financial Reporting",
          "Clean up and Catch-Up Bookkeeping",
          "Sales Taxes",
          "Cash Flow Management",
          "Categorizing expensive",
          "1099 filing",
          "Payroll",
          "QuickBooks online or Desktop and more…"
        ],
        marketingDetails: "We can help and support you and your company in some new technology services like social marketing, web design, computer network, help-desk & others IT services. We can promote your business in the social media marketing to Help U increase its costumer base and grow your incomes. It is the new way to do marketing!!!!\n\nIf you need a modern, mobile-responsive and attractive website or renew your old site, we can do it fast and affordable prices. We can include hosting and domain register.\n\nWe are able to Help U in a hardware and/or software networking works, Backups on clouds technologies, help desk options and more."
      },
      customers: {
        title: "Some of Our Great and Successful Customers & Partners",
        subtitle: "...and many more!"
      },
      news: {
        title: "In The News Today",
        readMore: "Read More"
      },
      contact: {
        title: "Contact Us",
        subtitle: "Get in touch with our team",
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        serviceInterest: "Service Interest",
        selectService: "Select a service",
        submit: "Send Message",
        sending: "Sending...",
        success: "Message sent successfully!",
        error: "Error sending message. Please try again."
      },
      footer: {
        rights: "All rights reserved.",
        tagline: "Always Helping You In Your Needs"
      }
    },
    es: {
      nav: {
        home: "Inicio",
        about: "Acerca de Nosotros",
        services: "Servicios",
        customers: "Clientes",
        news: "Noticias",
        contact: "Contacto"
      },
      hero: {
        title: "Asesoramiento Profesional Directamente de Nuestros Expertos",
        subtitle: "Ofrecemos una amplia gama de servicios profesionales relacionados con la contabilidad",
        description: "Servicios de contabilidad para pequeñas y medianas empresas, Nóminas, Formación de nuevas empresas, revisiones, Consultoría de integración empresarial y más.",
        cta: "Contáctenos"
      },
      about: {
        title: "Acerca de Nosotros",
        subtitle: "Conozca nuestra historia",
        content: "Una empresa familiar fundada desde 2008. Somos un equipo de profesionales y un grupo dedicado de individuos que aman cuidar de nuestros clientes con más de 30 años de experiencia. Estamos siempre listos para ayudarle en todas sus necesidades. Podemos apoyarle en algunas áreas profesionales como servicios de contabilidad, marketing social, diseño web y otros servicios de TI. Siempre ayudándole en todas sus necesidades."
      },
      services: {
        title: "Nuestros Servicios",
        subtitle: "Soluciones integrales para las necesidades de su negocio",
        learnMore: "Saber Más",
        close: "Cerrar",
        accountingDetails: "Ofrecemos un conjunto completo de servicios de contabilidad financiera de gestión para pequeñas y medianas empresas. Ofrecemos contabilidad de gestión empresarial, Soluciones Intuit QuickBooks y otros programas financieros, gestión de nóminas, consultoría financiera para pequeñas empresas y más... permitiendo a los propietarios de negocios no sólo ahorrar dinero en contabilidad interna y garantizar su cumplimiento con las leyes fiscales, sino tomar decisiones valiosas de gestión a partir de sus números. También ofrecemos la oportunidad de ayudar a su empresa con nuestros socios sobre sus impuestos corporativos y diligencias debidas, inventario integrado y software de gestión corporativa y mucho más.",
        bookkeepingServicesTitle: "Algunos servicios de contabilidad:",
        bookkeepingServicesList: [
          "Cuentas por Pagar y por Cobrar",
          "Conciliación Bancaria",
          "Informes Financieros",
          "Limpieza y Contabilidad Atrasada (Catch-Up)",
          "Impuestos sobre Ventas",
          "Gestión de Flujo de Efectivo",
          "Categorización de Gastos",
          "Presentación de 1099",
          "Nómina",
          "QuickBooks Online o Escritorio y más…"
        ],
        marketingDetails: "Podemos ayudar y apoyar a usted y su empresa en algunos nuevos servicios tecnológicos como marketing social, diseño web, red de computadoras, help-desk y otros servicios de TI. Podemos promocionar su negocio en el marketing de redes sociales para ayudarle a aumentar su base de clientes y hacer crecer sus ingresos. ¡Es la nueva forma de hacer marketing!\n\nSi necesita un sitio web moderno, adaptable a dispositivos móviles y atractivo, o renovar su sitio antiguo, podemos hacerlo rápido y a precios asequibles. Podemos incluir hosting y registro de dominio.\n\nPodemos ayudarle en trabajos de redes de hardware y/o software, copias de seguridad en tecnologías de nube, opciones de help desk y más."
      },
      customers: {
        title: "Algunos de Nuestros Grandes y Exitosos Clientes y Socios",
        subtitle: "...¡y muchos más!"
      },
      news: {
        title: "En Las Noticias Hoy",
        readMore: "Leer Más"
      },
      contact: {
        title: "Contáctenos",
        subtitle: "Póngase en contacto con nuestro equipo",
        name: "Nombre",
        email: "Correo Electrónico",
        phone: "Teléfono",
        message: "Mensaje",
        serviceInterest: "Servicio de Interés",
        selectService: "Seleccione un servicio",
        submit: "Enviar Mensaje",
        sending: "Enviando...",
        success: "¡Mensaje enviado exitosamente!",
        error: "Error al enviar el mensaje. Por favor, inténtelo de nuevo."
      },
      footer: {
        rights: "Todos los derechos reservados.",
        tagline: "Siempre Ayudándole en Sus Necesidades"
      }
    }
  };

  const text = t[language];

  return (
    <div className="App min-h-screen bg-gray-50">
      {/* Navigation */}
      <nav className="bg-white shadow-md fixed w-full top-0 z-50" data-testid="main-navigation">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-28">
            <div className="flex-shrink-0">
              <a href="#home" className="block" data-testid="company-logo-link" aria-label="Help U Way Corp - Home">
                <img
                  src="/images/nav-logo.png"
                  alt="Help U Way Corp"
                  className="h-24 w-auto object-contain"
                  data-testid="company-logo"
                />
                <h1 className="sr-only">Help U Way Corp</h1>
              </a>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="#home" className="text-gray-700 hover:text-red-600 transition" data-testid="nav-home">{text.nav.home}</a>
              <button onClick={() => setShowAboutModal(true)} className="text-gray-700 hover:text-red-600 transition" data-testid="nav-about">{text.nav.about}</button>
              <a href="#services" className="text-gray-700 hover:text-red-600 transition" data-testid="nav-services">{text.nav.services}</a>
              <a href="#customers" className="text-gray-700 hover:text-red-600 transition" data-testid="nav-customers">{text.nav.customers}</a>
              <a href="#news" className="text-gray-700 hover:text-red-600 transition" data-testid="nav-news">{text.nav.news}</a>
              <a href="#contact" className="text-gray-700 hover:text-red-600 transition" data-testid="nav-contact">{text.nav.contact}</a>
              <button
                onClick={() => setLanguage(language === "en" ? "es" : "en")}
                className="flex items-center space-x-1 text-gray-700 hover:text-red-600 transition"
                data-testid="language-toggle"
              >
                <Globe className="w-5 h-5" />
                <span>{language === "en" ? "ES" : "EN"}</span>
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="text-gray-700 hover:text-red-600"
                data-testid="mobile-menu-toggle"
              >
                {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <div className="md:hidden pb-4" data-testid="mobile-menu">
              <a href="#home" className="block py-2 text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>{text.nav.home}</a>
              <button onClick={() => { setShowAboutModal(true); setMobileMenuOpen(false); }} className="block py-2 text-gray-700 hover:text-red-600 w-full text-left">{text.nav.about}</button>
              <a href="#services" className="block py-2 text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>{text.nav.services}</a>
              <a href="#customers" className="block py-2 text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>{text.nav.customers}</a>
              <a href="#news" className="block py-2 text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>{text.nav.news}</a>
              <a href="#contact" className="block py-2 text-gray-700 hover:text-red-600" onClick={() => setMobileMenuOpen(false)}>{text.nav.contact}</a>
              <button
                onClick={() => setLanguage(language === "en" ? "es" : "en")}
                className="flex items-center space-x-1 py-2 text-gray-700 hover:text-blue-600"
              >
                <Globe className="w-5 h-5" />
                <span>{language === "en" ? "ES" : "EN"}</span>
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="pt-36 pb-20 bg-gradient-to-br from-red-600 to-red-800 text-white" data-testid="hero-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-testid="hero-title">{text.hero.title}</h2>
            <p className="text-xl md:text-2xl mb-4 text-red-100" data-testid="hero-subtitle">{text.hero.subtitle}</p>
            <p className="text-lg mb-8 text-red-50 max-w-3xl mx-auto" data-testid="hero-description">{text.hero.description}</p>
            <div className="flex flex-col items-center gap-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-center">
              {/* Left spacer (desktop only) for balance */}
              <div className="hidden sm:block" aria-hidden="true"></div>

              {/* Contact Us — centered */}
              <div className="flex justify-center">
                <a
                  href="#contact"
                  className="inline-flex items-center px-8 py-3 bg-white text-red-600 rounded-lg font-semibold hover:bg-red-50 transition shadow-lg"
                  data-testid="hero-cta-button"
                >
                  {text.hero.cta}
                  <ChevronRight className="ml-2 w-5 h-5" />
                </a>
              </div>

              {/* Google Reviews — right aligned on desktop */}
              <div className="flex justify-center sm:justify-end">
                <a
                  href="https://share.google/pL6zrVzmtVAbDa8bc"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group inline-flex items-center gap-4 bg-white rounded-2xl shadow-xl px-6 py-4 hover:shadow-2xl hover:scale-105 transition transform"
                  data-testid="hero-google-reviews-badge"
                  aria-label="See our 5-star Google Reviews"
                  title={language === "en" ? "Read our 5-star Google Reviews" : "Lee nuestras reseñas de Google de 5 estrellas"}
                >
                  {/* Google "G" logo */}
                  <svg className="w-12 h-12 flex-shrink-0" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/>
                    <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/>
                    <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"/>
                    <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/>
                  </svg>
                  {/* Stars + Google Reviews text */}
                  <div className="flex flex-col items-start">
                    <div className="flex items-center gap-0.5 mb-1">
                      {[0,1,2,3,4].map((i) => (
                        <svg key={i} className="w-5 h-5" fill="#FBBC05" viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M12 .587l3.668 7.568L24 9.75l-6 5.847L19.336 24 12 19.897 4.664 24 6 15.597 0 9.75l8.332-1.595z"/>
                        </svg>
                      ))}
                      <span className="ml-1.5 text-sm font-bold text-gray-700">5.0</span>
                    </div>
                    <div className="text-base font-semibold leading-none whitespace-nowrap">
                      <span className="text-[#4285F4]">G</span>
                      <span className="text-[#EA4335]">o</span>
                      <span className="text-[#FBBC05]">o</span>
                      <span className="text-[#4285F4]">g</span>
                      <span className="text-[#34A853]">l</span>
                      <span className="text-[#EA4335]">e</span>
                      <span className="text-gray-700"> Reviews</span>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-white" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-testid="services-title">{text.services.title}</h2>
            <p className="text-xl text-gray-600" data-testid="services-subtitle">{text.services.subtitle}</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={service.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition" data-testid={`service-card-${service.id}`}>
                <div className="h-48 overflow-hidden">
                  <img src={service.image_url} alt={language === "en" ? service.title_en : service.title_es} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    {service.icon === "calculator" && <Calculator className="w-8 h-8 text-red-600" />}
                    {service.icon === "trending-up" && <TrendingUp className="w-8 h-8 text-red-600" />}
                    {service.icon === "briefcase" && <Briefcase className="w-8 h-8 text-red-600" />}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-testid={`service-title-${service.id}`}>
                    {language === "en" ? service.title_en : service.title_es}
                  </h3>
                  <p className="text-gray-600 mb-4" data-testid={`service-description-${service.id}`}>
                    {language === "en" ? service.description_en : service.description_es}
                  </p>
                  <button 
                    onClick={() => setSelectedService(service)} 
                    className="inline-flex items-center text-red-600 font-semibold hover:text-red-700" 
                    data-testid={`service-link-${service.id}`}
                  >
                    {text.services.learnMore}
                    <ChevronRight className="ml-1 w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News Article Modal */}
      {selectedNews && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setSelectedNews(null)}>
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <div className="flex-1">
                  <span className="inline-block px-3 py-1 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-3">
                    {selectedNews.category}
                  </span>
                  <h3 className="text-3xl font-bold text-gray-900">
                    {language === "en" ? selectedNews.title_en : selectedNews.title_es}
                  </h3>
                </div>
                <button 
                  onClick={() => setSelectedNews(null)} 
                  className="text-gray-400 hover:text-gray-600 ml-4"
                  data-testid="close-news-modal"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              
              <div className="mb-6">
                <img 
                  src={selectedNews.image_url} 
                  alt={language === "en" ? selectedNews.title_en : selectedNews.title_es}
                  className="w-full max-h-[28rem] object-contain rounded-lg bg-gray-50"
                />
                {(selectedNews.image_caption_en || selectedNews.image_caption_es) && (
                  <p className="mt-2 text-sm italic text-gray-500 text-center" data-testid="news-image-caption">
                    {language === "en"
                      ? (selectedNews.image_caption_en || selectedNews.image_caption_es)
                      : (selectedNews.image_caption_es || selectedNews.image_caption_en)}
                  </p>
                )}
              </div>
              
              <div className="prose prose-lg max-w-none">
                <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                  {language === "en" ? selectedNews.content_en : selectedNews.content_es}
                </div>
                {selectedNews.source_url && (
                  <p className="mt-6 text-sm text-gray-600" data-testid="news-source-link">
                    <span className="font-semibold">
                      {language === "en" ? "Source: " : "Fuente: "}
                    </span>
                    <a
                      href={selectedNews.source_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-red-600 hover:text-red-700 underline break-all"
                    >
                      {selectedNews.source_url.replace(/^https?:\/\//, "")}
                    </a>
                  </p>
                )}
              </div>
              
              <div className="mt-8 flex justify-end">
                <button
                  onClick={() => setSelectedNews(null)}
                  className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  {text.services.close}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* About Us Modal */}
      {showAboutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setShowAboutModal(false)}>
          <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <h3 className="text-3xl font-bold text-gray-900">
                  {text.about.title}
                </h3>
                <button 
                  onClick={() => setShowAboutModal(false)} 
                  className="text-gray-400 hover:text-gray-600"
                  data-testid="close-about-modal"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              
              <p className="text-lg text-gray-600 mb-6">{text.about.subtitle}</p>
              
              <div className="grid md:grid-cols-2 gap-8 items-start">
                {/* Image */}
                <div>
                  <img 
                    src="/images/about-team.png" 
                    alt="Help U Way Corp Team" 
                    className="rounded-lg shadow-lg w-full"
                    data-testid="about-modal-image"
                  />
                </div>
                
                {/* Content */}
                <div>
                  <p className="text-gray-700 text-lg leading-relaxed mb-6" data-testid="about-modal-content">
                    {text.about.content}
                  </p>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div className="text-center p-4 bg-red-50 rounded-lg">
                      <p className="text-3xl font-bold text-red-600">2008</p>
                      <p className="text-gray-600 text-sm mt-1">{language === "en" ? "Founded" : "Fundada"}</p>
                    </div>
                    <div className="text-center p-4 bg-red-50 rounded-lg">
                      <p className="text-3xl font-bold text-red-600">30+</p>
                      <p className="text-gray-600 text-sm mt-1">{language === "en" ? "Years Experience" : "Años de Experiencia"}</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 flex justify-end">
                <button
                  onClick={() => setShowAboutModal(false)}
                  className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  {text.services.close}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Service Details Modal */}
      {selectedService && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" onClick={() => setSelectedService(null)}>
          <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="p-8">
              <div className="flex justify-between items-start mb-6">
                <div className="flex items-center space-x-4">
                  {selectedService.icon === "calculator" && <Calculator className="w-10 h-10 text-red-600" />}
                  {selectedService.icon === "trending-up" && <TrendingUp className="w-10 h-10 text-red-600" />}
                  {selectedService.icon === "briefcase" && <Briefcase className="w-10 h-10 text-red-600" />}
                  <h3 className="text-3xl font-bold text-gray-900">
                    {language === "en" ? selectedService.title_en : selectedService.title_es}
                  </h3>
                </div>
                <button 
                  onClick={() => setSelectedService(null)} 
                  className="text-gray-400 hover:text-gray-600"
                  data-testid="close-modal-button"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              
              <div className="mb-6">
                <img 
                  src={selectedService.image_url} 
                  alt={language === "en" ? selectedService.title_en : selectedService.title_es}
                  className="w-full h-64 object-cover rounded-lg"
                />
              </div>
              
              <div className="text-gray-700 leading-relaxed mb-6">
                {selectedService.id === "accounting" ? (
                  <div className="text-lg space-y-4">
                    <p>{text.services.accountingDetails}</p>
                    <div className="flex justify-end items-center gap-4 py-2" data-testid="intuit-quickbooks-inline-logo">
                      <img
                        src="/images/intuit-proadvisor-gold.png"
                        alt="Intuit ProAdvisor Gold"
                        className="h-16 md:h-20 w-auto object-contain"
                        data-testid="intuit-proadvisor-badge-modal"
                      />
                      <img
                        src="/images/quickbooks-black.webp"
                        alt="Intuit QuickBooks"
                        className="h-14 md:h-16 w-auto object-contain"
                      />
                    </div>
                    <div className="bg-gray-50 border-l-4 border-red-600 p-5 rounded-r-lg">
                      <h4 className="font-bold text-gray-900 mb-3" data-testid="bookkeeping-services-title">
                        {text.services.bookkeepingServicesTitle}
                      </h4>
                      <ul className="list-disc list-inside space-y-2 text-gray-700" data-testid="bookkeeping-services-list">
                        {text.services.bookkeepingServicesList.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ) : selectedService.id === "marketing" ? (
                  <div className="text-lg space-y-4">
                    {text.services.marketingDetails.split('\n\n').map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                ) : (
                  <p className="text-lg">{language === "en" ? selectedService.description_en : selectedService.description_es}</p>
                )}
              </div>
              
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setSelectedService(null)}
                  className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  {text.services.close}
                </button>
                <a
                  href="#contact"
                  onClick={() => setSelectedService(null)}
                  className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                  data-testid="modal-contact-button"
                >
                  {text.hero.cta}
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Customers Section */}
      {customers.length > 0 && (
        <section id="customers" className="py-20 bg-gray-50" data-testid="customers-section">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-testid="customers-title">{text.customers.title}</h2>
              <p className="text-xl text-gray-600" data-testid="customers-subtitle">{text.customers.subtitle}</p>
            </div>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
              {customers.map((customer) => (
                <a
                  key={customer.id}
                  href={customer.website_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white rounded-lg shadow-md p-6 hover:shadow-xl transition flex flex-col items-center justify-center"
                  data-testid={`customer-card-${customer.id}`}
                >
                  <div className="h-28 w-full flex items-center justify-center mb-4 overflow-hidden">
                    <img
                      src={customer.logo_url}
                      alt={customer.name}
                      className={`max-h-28 max-w-full object-contain ${customer.name?.toLowerCase().includes("tania") ? "scale-125" : ""}`}
                      onError={(e) => {
                        // Replace broken logo with a clean styled name placeholder
                        const initials = customer.name
                          .split(/\s+/)
                          .map((w) => w[0])
                          .filter(Boolean)
                          .slice(0, 2)
                          .join("")
                          .toUpperCase();
                        const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 80'><rect width='200' height='80' rx='8' fill='#fef2f2'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-family='system-ui, -apple-system, sans-serif' font-size='28' font-weight='700' fill='#dc2626'>${initials}</text></svg>`;
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
                      }}
                    />
                  </div>
                  <h4 className="text-center font-semibold text-gray-900" data-testid={`customer-name-${customer.id}`}>{customer.name}</h4>
                </a>
              ))}
            </div>

            {/* Additional Customers - Light Grey List */}
            <div className="mt-12 max-w-5xl mx-auto text-center" data-testid="additional-customers">
              <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-gray-300 text-lg md:text-xl leading-relaxed font-bold italic" style={{ fontFamily: "'Barlow', system-ui, -apple-system, sans-serif" }}>
                {[
                  "Solidum Builders",
                  "AB Square Builders",
                  "Abitare",
                  "Alvarez Cujino Associates",
                  "Huot Holdings",
                  "IZE Graphics",
                  "Key Point Properties",
                  "Kuhl Investments",
                  "Parnasa",
                  "Loramel",
                  "Magicol",
                  "One Plus Insurance",
                  "Pastificio Bolognese",
                  "Reel Restoration",
                  "SQ Prosperous",
                  "ST Joseph Investments",
                  "Teresta Group"
                ].map((name, idx, arr) => (
                  <span key={name} className="inline-flex items-center">
                    <span className="hover:text-gray-500 transition-colors">{name}</span>
                    {idx < arr.length - 1 && (
                      <span className="ml-3 text-gray-200 not-italic font-normal" aria-hidden="true">•</span>
                    )}
                  </span>
                ))}
                <span className="ml-3 text-gray-300">
                  {language === "en" ? "and many more..." : "y muchos más..."}
                </span>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* News Section */}
      {news.length > 0 && (
        <section id="news" className="py-20 bg-white" data-testid="news-section">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-testid="news-title">{text.news.title}</h2>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              {news.map((article) => (
                <div 
                  key={article.id} 
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition cursor-pointer" 
                  onClick={() => setSelectedNews(article)}
                  data-testid={`news-article-${article.id}`}
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={article.image_url}
                      alt={language === "en" ? article.title_en : article.title_es}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        const title = language === "en" ? article.title_en : article.title_es;
                        const safeTitle = (title || "News").replace(/[<>&]/g, "").slice(0, 40);
                        const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 192'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#dc2626'/><stop offset='1' stop-color='#7f1d1d'/></linearGradient></defs><rect width='400' height='192' fill='url(#g)'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-family='system-ui, -apple-system, sans-serif' font-size='22' font-weight='700' fill='white'>${safeTitle}</text></svg>`;
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
                      }}
                    />
                  </div>
                  <div className="p-6">
                    <span className="inline-block px-3 py-1 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-3">
                      {article.category}
                    </span>
                    <h3 className="text-xl font-bold text-gray-900 mb-3" data-testid={`news-article-title-${article.id}`}>
                      {language === "en" ? article.title_en : article.title_es}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-3" data-testid={`news-article-content-${article.id}`}>
                      {language === "en" ? article.content_en : article.content_es}
                    </p>
                    <button className="inline-flex items-center text-red-600 font-semibold hover:text-red-700">
                      {text.news.readMore}
                      <ChevronRight className="ml-1 w-4 h-4" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gray-50" data-testid="contact-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-testid="contact-title">{text.contact.title}</h2>
            <p className="text-xl text-gray-600" data-testid="contact-subtitle">{text.contact.subtitle}</p>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg p-8">
            <form onSubmit={handleSubmit} data-testid="contact-form">
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-testid="contact-name-label">{text.contact.name}</label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    data-testid="contact-name-input"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-testid="contact-email-label">{text.contact.email}</label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    data-testid="contact-email-input"
                  />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-testid="contact-phone-label">{text.contact.phone}</label>
                  <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    data-testid="contact-phone-input"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-testid="contact-service-label">{text.contact.serviceInterest}</label>
                  <select
                    value={formData.service_interest}
                    onChange={(e) => setFormData({ ...formData, service_interest: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    data-testid="contact-service-select"
                  >
                    <option value="">{text.contact.selectService}</option>
                    {services.map((service) => (
                      <option key={service.id} value={service.id}>
                        {language === "en" ? service.title_en : service.title_es}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-testid="contact-message-label">{text.contact.message}</label>
                <textarea
                  required
                  rows="5"
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  data-testid="contact-message-textarea"
                ></textarea>
              </div>
              <button
                type="submit"
                disabled={submitStatus === "sending"}
                className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition disabled:bg-gray-400"
                data-testid="contact-submit-button"
              >
                {submitStatus === "sending" ? text.contact.sending : text.contact.submit}
              </button>
              {submitStatus === "success" && (
                <p className="mt-4 text-green-600 text-center" data-testid="contact-success-message">{text.contact.success}</p>
              )}
              {submitStatus === "error" && (
                <p className="mt-4 text-red-600 text-center" data-testid="contact-error-message">{text.contact.error}</p>
              )}
            </form>
          </div>

          {/* Contact Info */}
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            <div className="flex items-center space-x-3" data-testid="contact-info-email">
              <Mail className="w-6 h-6 text-red-600" />
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <p className="font-semibold">info@helpuway.com</p>
              </div>
            </div>
            <div className="flex items-center space-x-3" data-testid="contact-info-phone">
              <Phone className="w-6 h-6 text-red-600" />
              <div>
                <p className="text-sm text-gray-500">Phone</p>
                <p className="font-semibold">+1 (954) 380-9495</p>
              </div>
            </div>
            <div className="flex items-center space-x-3" data-testid="contact-info-location">
              <MapPin className="w-6 h-6 text-red-600" />
              <div>
                <p className="text-sm text-gray-500">Location</p>
                <p className="font-semibold">Miami, FL</p>
              </div>
            </div>
          </div>

          {/* Intuit ProAdvisor Gold Badge */}
          <div className="mt-10 flex justify-end" data-testid="contact-proadvisor-badge">
            <img
              src="/images/intuit-proadvisor-gold.png"
              alt="Intuit ProAdvisor Gold"
              className="h-28 md:h-32 w-auto object-contain"
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12" data-testid="footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            {/* Logo on the left */}
            <div className="mb-6 md:mb-0">
              <img 
                src="/images/footer-logo.png" 
                alt="Help U Way Corp Logo" 
                className="h-24 w-auto"
                data-testid="footer-logo"
              />
            </div>
            
            {/* Center content */}
            <div className="text-center flex-1">
              <h3 className="text-2xl font-bold mb-4" data-testid="footer-company-name">Help U Way Corp</h3>
              <p className="text-gray-400 mb-4" data-testid="footer-tagline">{text.footer.tagline}</p>
              <p className="text-gray-500" data-testid="footer-copyright">&copy; {new Date().getFullYear()} Help U Way Corp. {text.footer.rights}</p>
            </div>
            
            {/* Right side: Intuit Solution Provider */}
            <div className="mt-6 md:mt-0 flex items-center gap-3" data-testid="intuit-solution-provider">
              <span className="text-white font-semibold text-sm md:text-base whitespace-nowrap">
                Intuit Solution Provider
              </span>
              <img
                src="/images/quickbooks-white.webp"
                alt="Intuit QuickBooks"
                className="h-10 md:h-12 w-auto object-contain"
                data-testid="intuit-quickbooks-logo"
              />
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
